function requestReviewDialogDirective () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/request-review/request-review-dialog.html?$$REVISION$$'
  }
}

export { requestReviewDialogDirective }
